import React, { useState } from "react";
import Select from "react-select";
import axios from "../../utils/axiosInstance";
import { toastSuccess, toastError } from "../../utils/alertHelper"; 

const ChapterSelectionModal = ({
  visible,
  onCancel,
  chapters = [], 
  selectedUser,
  onTransferSuccess, 
}) => {
  const [oldChapter, setOldChapter] = useState(null);
  const [newChapter, setNewChapter] = useState(null);
  const [loading, setLoading] = useState(false);

  if (!visible) return null;

  // Get user's current chapters for old chapter dropdown
  const userChapters = selectedUser?.chapter?.map(ch => ({ 
    value: ch._id || ch.id, 
    label: ch.name 
  })) || [];

  const handleConfirm = async () => {
    if (!oldChapter || !newChapter) {
      alert("Please select both old and new chapters");
      return;
    }
    if (oldChapter.value === newChapter.value) {
      alert("Old and new chapter cannot be the same");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post("/api/transfer", {
        user: selectedUser?._id || selectedUser?.id,
        oldChapter: oldChapter.value,
        newchapter: newChapter.value,
      });

      if (response.data.Status === 1) {
        toastSuccess(response.data.Message || "Chapter transferred successfully");
        if (onTransferSuccess) onTransferSuccess(response.data);

        setOldChapter(null);
        setNewChapter(null);
        onCancel(); // close modal
      } else {
        toastError(response.data.Message || "Transfer failed");
      }
    } catch (error) {
      console.error('Transfer error:', error);
      toastError(error.response?.data?.Message || error.response?.data?.message || "Transfer failed");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setOldChapter(null);
    setNewChapter(null);
    onCancel();
  };

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}
    >
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Transfer Chapter - {selectedUser?.firstName} {selectedUser?.lastName}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleCancel}
            ></button>
          </div>

          <div className="modal-body">
            <div className="row">
              {/* Old Chapter Dropdown */}
              <div className="col-md-6">
                <label className="form-label">Old Chapter</label>
                <Select
                  options={userChapters}
                  value={oldChapter}
                  onChange={(val) => setOldChapter(val)}
                  placeholder="Select old chapter..."
                  isSearchable={true}
                />
              </div>

              {/* New Chapter Dropdown */}
              <div className="col-md-6">
                <label className="form-label">New Chapter</label>
                <Select
                  options={chapters}
                  value={newChapter}
                  onChange={(val) => setNewChapter(val)}
                  placeholder="Select new chapter..."
                  isSearchable={true}
                />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={handleCancel}>
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleConfirm}
              disabled={!oldChapter || !newChapter || loading}
              style={{ backgroundColor: "#F36B24", borderColor: "#F36B24" }}
            >
              {loading ? "Transferring..." : "Transfer"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChapterSelectionModal;
